import { apiSlice } from './apiSlice';

export interface planetaryTransitsFromMoon {
  planet: string;
  sign: string;
  degree: string;
  awastha: string;
  signLord: string;
  nakshatra: string;
  nakshatraPada: number;
  nakshatraLord: string;
  house: number;
}

export interface PlanetaryPositionFromMoonResponse {
  data: planetaryTransitsFromMoon[];

  planetaryTransitsFromMoon?: planetaryTransitsFromMoon[];
}

export const planetaryPositionFromMoonApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetaryPositionFromMoon: builder.query<PlanetaryPositionFromMoonResponse, string | null>({
      query: (userId) => ({
        url: '/astrology/planetaryPositions',
        method: 'GET',
        params: { userId },
      }),
    }),
  }),
});

export const { useGetPlanetaryPositionFromMoonQuery } = planetaryPositionFromMoonApi;
